<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-delete-document`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 2l9 9.429V24h-4v-9.962l-8 .001L29.999 6H10v36h13v4H8a2 2 0 01-2-2V4a2 2 0 012-2h25zm2.07 32.24l4.75-4.75c.315-.315.462-.396.639-.45a.908.908 0 01.534 0c.177.054.324.135.64.45l1.015 1.016c.315.315.397.462.45.64a.908.908 0 010 .534c-.053.177-.135.324-.45.639l-4.75 4.75 4.75 4.75c.315.316.397.463.45.64a.908.908 0 010 .534c-.053.177-.135.324-.45.64l-1.015 1.015c-.316.315-.463.397-.64.45a.908.908 0 01-.534 0c-.177-.053-.324-.135-.64-.45l-4.75-4.75-4.75 4.75c-.315.315-.462.397-.64.45a.908.908 0 01-.534 0c-.177-.053-.324-.135-.639-.45l-1.015-1.015c-.316-.316-.397-.463-.45-.64a.908.908 0 010-.534c.053-.177.134-.324.45-.64l4.75-4.75-4.75-4.75c-.316-.315-.397-.462-.45-.64a.908.908 0 010-.534c.053-.177.134-.324.45-.639l1.015-1.015c.315-.316.462-.397.64-.45a.908.908 0 01.534 0c.177.053.324.134.639.45l4.75 4.75z"/></svg>
</template>
<script>

export default {
  name: 'IconDeleteDocument',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
